import {
  SubjectColorKeys,
  type ColorScale,
  type SubjectColors,
} from "../../semantic/colors";

export type SubjectTone =
  | "primary"
  | "warning"
  | "success"
  | "error"
  | "tertiary";

type SubjectToneScales = Record<SubjectTone, ColorScale>;

const subjectToneMap: Record<string, SubjectTone> = {
  [SubjectColorKeys.Chem]: "primary",
  [SubjectColorKeys.Chemistry]: "primary",
  [SubjectColorKeys.Phy]: "warning",
  [SubjectColorKeys.Physics]: "warning",
  [SubjectColorKeys.Bio]: "success",
  [SubjectColorKeys.Biology]: "success",
  [SubjectColorKeys.Botany]: "success",
  [SubjectColorKeys.Math]: "tertiary",
  [SubjectColorKeys.Maths]: "tertiary",
  [SubjectColorKeys.Mat]: "tertiary",
  [SubjectColorKeys.Mathematics]: "tertiary",
  [SubjectColorKeys.MathAppliedMath]: "tertiary",
  [SubjectColorKeys.AppliedMathematics]: "tertiary",
  [SubjectColorKeys.Arithmetic]: "primary",
  [SubjectColorKeys.Eng]: "error",
  [SubjectColorKeys.English]: "error",
  [SubjectColorKeys.EnglishV1]: "error",
  [SubjectColorKeys.EnglishEnhancementProgram]: "primary",
  [SubjectColorKeys.Zoology]: "success",
  [SubjectColorKeys.Sci]: "warning",
  [SubjectColorKeys.Science]: "warning",
  [SubjectColorKeys.Evs]: "success",
  [SubjectColorKeys.EnvironmentalStudy]: "success",
  [SubjectColorKeys.Hindi]: "error",
  [SubjectColorKeys.Telugu]: "primary",
  [SubjectColorKeys.Cs]: "warning",
  [SubjectColorKeys.ComputerScience]: "warning",
  [SubjectColorKeys.Social]: "error",
  [SubjectColorKeys.SocialStudies]: "error",
  [SubjectColorKeys.Civics]: "error",
  [SubjectColorKeys.Geo]: "error",
  [SubjectColorKeys.Geography]: "error",
  [SubjectColorKeys.History]: "error",
  [SubjectColorKeys.Reasoning]: "primary",
  [SubjectColorKeys.MentalAbility]: "error",
  [SubjectColorKeys.Logical]: "error",
  [SubjectColorKeys.Gk]: "error",
  [SubjectColorKeys.GeneralTest]: "error",
  [SubjectColorKeys.Stats]: "tertiary",
  [SubjectColorKeys.Commerce]: "tertiary",
  [SubjectColorKeys.Business]: "tertiary",
  [SubjectColorKeys.Eco]: "tertiary",
  [SubjectColorKeys.Economics]: "tertiary",
  [SubjectColorKeys.Hots]: "primary",
  [SubjectColorKeys.Intso]: "primary",
  [SubjectColorKeys.Nasa]: "primary",
  [SubjectColorKeys.Kat]: "primary",
  [SubjectColorKeys.CriticalThinking]: "error",
  [SubjectColorKeys.ProblemSolving]: "tertiary",
  [SubjectColorKeys.VedicMath]: "tertiary",
  [SubjectColorKeys.VedicMathmatics]: "tertiary",
  [SubjectColorKeys.EnvironmentalStudies]: "success",
  [SubjectColorKeys.LogicalReasoning]: "error",
};

export function buildSubjectColors(scales: SubjectToneScales): SubjectColors {
  return Object.fromEntries(
    Object.entries(subjectToneMap).map(([subjectKey, tone]) => [
      subjectKey,
      scales[tone],
    ]),
  ) as SubjectColors;
}
